type Role = {
  id: number;
  name: string;
};

export const USER_STATUS = {
  Active: 'Active',
  Inactive: 'Inactive',
  Suspended: 'Suspended',
  Invited: 'Invited',
} as const;

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS];

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  role?: Role;
  status: UserStatus;
}

export interface CurrentUser {
  id: number;
  first_name: string;
  last_name: string;
  full_name: string;
  email: string;
  phone_number?: string;
  cognito_id: string;
  created_at: string;
  last_logged_in_at: string;
  last_password_change_at?: string;
  role: Role;
  permissions: string[];
}

export interface UserInvitation {
  id: number;
  email: string;
  role_id: number;
  role?: Role;
  status: 'pending' | 'accepted' | 'expired';
  invited_by: number;
  invited_by_name?: string;
  created_at: string;
  expires_at: string;
}
